import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AssetsBridgeService } from "@modules/+new/assets/domain/+state/assets-bridge.service";
import { Fiat } from "@modules/+new/assets/domain/entities/fiat.model";
import { CryptoCoin } from "@modules/+new/assets/domain/entities/cryptocoin.model";

@Injectable({
	providedIn: "any"
})
export class AssetsFacade {
	public constructor(private bridgeService: AssetsBridgeService) {}

	// TODO implement new way to handle fiats
	// - get Fiats from remote service (API)
	// - cache Fiats in stateService
	// - but first check logic & dependencies in old services / models
	public getFiats$(): Observable<Fiat[]> {
		return this.bridgeService.getFiats$();
	}

	public getFiatById$(fiatId: number): Observable<Fiat> {
		return this.bridgeService.getFiatById$(fiatId);
	}

	public getDefaultFiat$(): Observable<Fiat> {
		return this.bridgeService.getDefaultFiat$();
	}

	// TODO implement new way to handle CryptoCoins
	// - get CryptoCoins from remote service (API)
	// - cache CryptoCoins in stateService
	// - but first check logic & dependencies in old services / models
	public getCryptoCoins$(): Observable<CryptoCoin[]> {
		return this.bridgeService.getCryptoCoins$();
	}
}
